// Consolidated existing site testimonials; duplicate authors use their fullest quote.
export const serviceTestimonials = [
  {
    name: 'Rob Snell',
    quote:
      'Kevin and the gang know their stuff. Highest possible recommendation.',
    image: '/people/reviews/rob-snell.webp',
  },
  {
    name: 'Tre McCune',
    quote:
      "Ventura Web Design has been an exceptional partner in collaboration with UPS Digital Connections. I've had the pleasure of working with Ventura on projects for clients ranging from startups to well-established businesses. Their team is highly responsive and takes a personalized approach, tailoring solutions to each business rather than applying a one-size-fits-all model.",
    image: '/people/reviews/tre-mccune-headshot.jpg',
    role: 'Senior Account Executive, UPS',
  },
  {
    name: 'Jose Hernandez',
    quote:
      "My customer has been optimistically fired up since partnering with Ventura Web Design & Marketing! Great job Kevin honing-in, understanding and uncovering my customer's growth challenges.",
    image: '/people/reviews/jose-hernandez.png',
  },
  {
    name: 'Justin Vance',
    quote:
      "Kevin and his team offer customizable solutions that are specific to one's needs. They take time to listen and truly understand your business model and its unique challenges. This allows Ventura to closely align their products and services to help boost sales, create brand awareness and simply enhance the overall customer experience. I highly recommend Ventura Web Design & Marketing to any small / medium sized business out there in search of professional consulting that's sure to yield effective and positive revenue and performance results.",
    image: '/people/reviews/justin-vance.webp',
    role: 'International Account Executive, UPS',
  },
  {
    name: 'Mark Christensen',
    quote:
      "Kevin and the team at Ventura are so easy to work with. From introductions to implementation, you can tell Ventura cares about the customer and their growth. If eCommerce growth is your company's goal, their thoroughness will shine, taking the time to understand the brand and journey of the online business. Thank you Ventura!",
    image: '/people/reviews/person.webp',
  },
  {
    name: 'Shirley Tan',
    quote:
      'Kevin is the consummate professional. Many web store owners that I have come to speak with highly recommend Ventura Web Design and continue to work with his team to grow their ecommerce business. We recently collaborated on a speaking panel and we worked thru the topic and logistics without missing a beat.',
    image: '/people/reviews/shirley.webp',
  },
  {
    name: 'Kristie Wagoner Cranford',
    quote:
      'Professional, creative solutions to taking web design to the next level. The customer service is very personal.',
    image: '/people/reviews/kristie-wagoner-cranford.webp',
  },
  {
    name: 'Phil Grier',
    quote:
      "I've worked with Ventura for years. They do great work at fair prices. Thanks for all of the help!",
    image: '/people/reviews/phil-grier.webp',
  },
  {
    name: 'Jen',
    quote:
      'I wanted to share the awesomeness of Kevin and Ventura. I just had an amazing meeting. He was so helpful in explaining IT lingo, software vs hosting, visibility, etc. He went to my website and diagnosed the issues we are facing with fraud and enlightened me on WooCommerce and the differences in some of these platforms. Kevin also gave me recommendations of ways to address those issues.',
    image: '/people/reviews/jen.webp',
  },
  {
    name: 'Kurt E.',
    quote:
      'I have had the opportunity to work with Ventura on a few projects and the team always provides great insights and direction.',
    image: '/people/reviews/kurt.webp',
  },
  {
    name: 'Alan Stock',
    quote:
      "All I can say is that they did an incredible job producing my website. They are very easy to work with, get the job done quickly and if there's ever a problem they correct it immediately. I cannot recommend them more...great folks!!",
    image: '/people/reviews/alan-stock.webp',
  },
  {
    name: 'Kevin D.',
    quote:
      'We are pleased with the work you all have done for us—expedient and thorough and cost effective. We expect you will hear from us again.',
    image: '/people/reviews/person.webp',
  },
  {
    name: 'Katie Polenzani',
    quote:
      "Working with Ventura has been such a positive experience—they're responsive, reliable, and genuinely invested in helping our business grow. I always feel supported and confident knowing they’re in our corner!",
    image: '/people/reviews/katie.png',
  },
  {
    name: 'Jose',
    quote:
      'I have had the pleasure of working with Ventura for the past 3 years. They are professional, responsive, and knowledgeable. I would recommend them to anyone looking to grow their business.',
    image: '/people/reviews/jose.webp',
  },
  {
    name: 'David Nolte',
    quote:
      'We have worked with Kevin and Ventura for more than 10 years. They have been an indispensible part of our team, enabling us to grow and manage our business, from IT needs to marketing programs. Highly recommend!',
    image: '/people/reviews/david-nolte.webp',
  },
  {
    name: 'Jamie',
    quote:
      'You are making an impact already! We look forward to great growth with you and your team.',
    image: '/people/reviews/jamie.webp',
  },
  {
    name: 'Jake Parsons',
    quote:
      "Partnering with Ventura Web Design has played a crucial role in my success in Sales at UPS. Their quick response times and dedication to outstanding customer service have allowed me to address client needs efficiently, creating strong relationships and trust. By utilizing Ventura's services, I've been able to offer cost-effective, innovative solutions that align with my clients' goals, enabling me to consistently meet and exceed sales targets.",
    image: '/people/reviews/jake-parsons.jpg',
    role: 'UPS',
  },
  {
    name: 'Jordan Ginnetti',
    quote:
      'Ventura Web Design made everything seamless not only for me, but especially for my customer, who felt well-supported and confident.',
    image: '/people/testimonials/jordan-ginnetti.jpeg',
    role: 'Customer Success Manager, UPS',
  },
  {
    name: 'Lindsey Chespak',
    quote:
      "Working with Ventura Web Design has been a great experience! They’re easy to communicate with, quick to respond, and really know what they’re doing. I’ve seen how much their work has helped my customers grow with clean, effective websites that get results. They're a solid team of people who genuinely care about doing great work and building real partnerships.",
    image: '/people/reviews/lindsey-chespak.jpeg',
    role: 'Customer Success Director, UPS',
  },
  {
    name: 'Dominique Secrest',
    quote:
      'This is a great collaborative example on how utilizing UPS Digital Connections Partners like Ventura Web Design helped us not only win the business but help this customer grow their business.',
    image: '/partners/ups/dom.jpeg',
    role: 'Director of Sales, UPS Healthcare',
  },
  {
    name: 'Chris Naf',
    quote:
      'Ventura was one of the value propositions we used to convert this long time FedEx customer. Rates were important, but the value set us apart as a true logistics partner in their future.',
    image: '/people/reviews/chris-naf.jpeg',
    role: 'Account Manager, UPS Healthcare',
  },
]
